var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme,
    on: {
      "pointermove": _vm.handlePointerMove
    }
  }, [_c('div', {
    staticClass: "zenBlocksPage page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "game-box gap-10"
  }, [_c('div', {
    ref: "topBox",
    staticClass: "game-top-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', [_c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.gameState.score))])])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count"
  }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.leftTime)))]), _c('div', {
    staticClass: "time-text"
  }, [_vm._v(_vm._s(_vm.$lang('Award and reset after countdown.')))])])]), _c('div', [_c('div', {
    staticClass: "bg-white/80 rounded relative",
    on: {
      "click": _vm.viewRank
    }
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "width": "18",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.prizePool))])])])]), _c('div', {
    ref: "gameCenterBox",
    staticClass: "game-center-box"
  }, [_c('div', {
    ref: "board",
    staticClass: "relative w-full aspect-square bg-slate-900/50 p-1 border border-slate-800 shadow-2xl grid-bg"
  }, [_c('div', {
    staticClass: "grid grid-cols-10 grid-rows-10 gap-[2px] h-full w-full"
  }, _vm._l(_vm.flatGrid, function (item) {
    return _c('div', {
      key: `${item.r}-${item.c}`,
      class: `w-full h-full rounded-[2px] transition-all duration-300 ${item.cell ? _vm.COLOR_MAP[item.cell] : 'bg-slate-800/40'}`
    });
  }), 0), _vm.activeBlock ? _c('PlacementHint', {
    attrs: {
      "grid": _vm.gameState.grid,
      "activeBlock": _vm.activeBlock,
      "dragPos": {
        x: _vm.dragPos.x,
        y: _vm.dragPos.y + _vm.DRAG_Y_OFFSET
      },
      "boardRect": _vm.boardRect
    }
  }) : _vm._e()], 1), _c('div', {
    ref: "availableBlocksBox",
    staticClass: "w-full flex justify-around items-center"
  }, _vm._l(_vm.gameState.availableBlocks, function (block, idx) {
    return _c('div', {
      key: idx,
      staticClass: "w-1/3 h-full flex justify-center items-center"
    }, [block ? _c('div', {
      staticClass: "touch-none cursor-grab active:scale-110 transition-transform p-4 flex items-center justify-center min-w-[80px] min-h-[80px]",
      on: {
        "pointerdown": e => _vm.handleDragStart(e, block, idx),
        "pointerup": _vm.handlePointerUp,
        "pointercancel": () => _vm.activeBlock = null
      }
    }, [_c('MiniBlock', {
      attrs: {
        "shape": block.shape,
        "color": block.color,
        "size": _vm.cellSize(0.7)
      }
    })], 1) : _c('div', {
      staticClass: "w-22 h-22 rounded-full border border-dashed border-slate-800 flex items-center justify-center"
    }, [_c('div', {
      staticClass: "w-1.5 h-1.5 rounded-full bg-slate-800"
    })])]);
  }), 0), _vm.activeBlock ? _c('div', {
    staticClass: "fixed pointer-events-none z-[60] transform -translate-x-1/2 -translate-y-1/2 will-change-transform",
    style: {
      left: _vm.dragPos.x - _vm.cellSize(1.09) + 'px',
      top: _vm.dragPos.y + _vm.DRAG_Y_OFFSET - _vm.cellSize(1.09) + 'px'
    }
  }, [_c('div', {
    staticClass: "scale-125 opacity-100 block-shadow"
  }, [_c('MiniBlock', {
    attrs: {
      "shape": _vm.activeBlock.block.shape,
      "color": _vm.activeBlock.block.color,
      "size": _vm.cellSize(1)
    }
  })], 1)]) : _vm._e()])])]), _c('pop-game-warn-prompt', {
    attrs: {
      "show": _vm.popOpenMobileShow,
      "message": _vm.$lang(`Please open this page on your mobile phone.`),
      "btnConfirmText": _vm.$lang('Back')
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenMobileShow = $event;
      },
      "confirm": function ($event) {
        return _vm.$router.back();
      }
    }
  }), _c('pop-game-start-prompt', {
    attrs: {
      "show": _vm.popStartShow,
      "message": _vm.$lang(`<li>Earn rewards by playing.</li>
<li>The higher your rank, the greater your reward.</li>
<li>Play multiple times within the countdown. Only your highest score will count for ranking.</li>
<li>All players will reset and start over once the countdown ends.</li>`)
    },
    on: {
      "update:show": function ($event) {
        _vm.popStartShow = $event;
      },
      "confirm": function ($event) {
        return _vm.resetGame();
      }
    }
  }), _c('pop-game-lost-prompt', {
    attrs: {
      "show": _vm.popLostShow,
      "title": _vm.$lang('Game over'),
      "message": _vm.$lang('Going beyond the limit, game over.'),
      "cancelText": _vm.revives > 0 ? _vm.$lang('Give up') : _vm.$lang('Restart (Score Resets)'),
      "confirmText": _vm.revives > 0 ? _vm.$lang(`Revive (${_vm.revives}/${_vm.maxRevives})`) : _vm.$lang('Restart')
    },
    on: {
      "update:show": function ($event) {
        _vm.popLostShow = $event;
      },
      "cancel": _vm.handleCancel,
      "confirm": function ($event) {
        return _vm.handleConfirm();
      }
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-rank', {
    attrs: {
      "gameType": 'zenBlocks',
      "show": _vm.popGameRankShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRankShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };